<template>
    <div class="error-container">
        <div class="dialog-window">
            <!-- Title Bar -->
            <div class="dialog-titlebar">
                <span class="dialog-title">10-4 - Erreur</span>
            </div>

            <!-- Content with icon and message -->
            <div class="dialog-content">
                <div class="dialog-icon">
                    <span class="icon-text">✕</span>
                </div>
                <div class="dialog-message">
                    <p class="error-message">Oupelaï ! Tu t'es perdu on dirait ?</p>
                    <p class="error-details">La page que vous recherchez n'existe pas.</p>
                </div>
            </div>

            <!-- Buttons -->
            <div class="dialog-buttons">
                <button class="btn-dialog btn-primary" @click="goHome">
                    Revenir au menu principale
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'NotFoundPage',
    methods: {
        goHome() {
            this.$router.push('/');
        }
    }
}
</script>

<style scoped>
.error-container {
    min-height: calc(100vh - var(--header-height));
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2rem;
    background: linear-gradient(to bottom, #f7d4d4 0%, #ffffff 50%, #f0f0f0 100%);
}

/* Windows 7 Error Dialog Window */
.dialog-window {
    width: 100%;
    max-width: 500px;
    background: #f0f0f0;
    border: 1px solid #d70000;
    border-radius: 8px 8px 0 0;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3), 0 2px 8px rgba(0, 0, 0, 0.2);
    overflow: hidden;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

/* Title Bar */
.dialog-titlebar {
    background: linear-gradient(to bottom, #f95c5c 0%, #d23b3b 50%, #b92929 100%);
    padding: 8px 12px;
    border-bottom: 1px solid #991e1e;
    display: flex;
    align-items: center;
}

.dialog-title {
    font-family: 'Orbitron', 'Impact', 'Arial Black', sans-serif;
    font-size: 1.2rem;
    font-weight: 700;
    color: #ffffff;
    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
    letter-spacing: 0.05em;
}

/* Content Area */
.dialog-content {
    display: flex;
    gap: 20px;
    padding: 24px;
    background: linear-gradient(to bottom, #ffffff 0%, #f7f7f7 100%);
    align-items: flex-start;
}

.dialog-icon {
    flex-shrink: 0;
    width: 48px;
    height: 48px;
    background: linear-gradient(135deg, #f95c5c 0%, #b92929 100%);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.icon-text {
    font-size: 28px;
    font-weight: bold;
    color: #ffffff;
    line-height: 1;
    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
}

.dialog-message {
    flex: 1;
}

.error-message {
    font-size: 1.1rem;
    font-weight: 600;
    line-height: 1.6;
    margin: 0 0 8px 0;
    color: #1a1a1a;
    text-align: left;
}

.error-details {
    font-size: 0.95rem;
    line-height: 1.6;
    margin: 0;
    color: #666;
    text-align: left;
}

/* Buttons Area */
.dialog-buttons {
    display: flex;
    gap: 8px;
    justify-content: flex-end;
    padding: 12px 16px;
    background: #f0f0f0;
    border-top: 1px solid #dfdfdf;
}

.btn-dialog {
    min-width: 80px;
    height: 24px;
    padding: 0 16px;
    font-size: 0.9rem;
    font-weight: 400;
    cursor: pointer;
    transition: all 0.1s ease;
    border-radius: 3px;
    font-family: 'Segoe UI', Tahoma, sans-serif;
}

.btn-primary {
    background: linear-gradient(to bottom, #fbfbfb 0%, #ebebeb 50%, #dddddd 100%);
    color: #1a1a1a;
    border: 1px solid #abadb3;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.8), 0 1px 2px rgba(0, 0, 0, 0.1);
}

.btn-primary:hover {
    background: linear-gradient(to bottom, #ffffff 0%, #f0f0f0 50%, #e5e5e5 100%);
    border-color: #7a7d85;
}

.btn-primary:active {
    background: linear-gradient(to bottom, #d5d5d5 0%, #e0e0e0 100%);
    box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.15);
}

/* Windows 7 selection for error page */
.error-container ::-moz-selection {
    background-color: #d70000;
    color: #fff;
}

.error-container ::selection {
    background-color: #d70000;
    color: #fff;
}

/* Responsive */
@media (max-width: 768px) {
    .dialog-window {
        max-width: 90%;
    }

    .dialog-content {
        flex-direction: column;
        align-items: center;
        text-align: center;
    }

    .dialog-icon {
        margin-bottom: 12px;
    }

    .error-message,
    .error-details {
        text-align: center;
    }

    .dialog-buttons {
        justify-content: center;
    }
}
</style>
